import React from 'react'
import { Modal } from 'src/Components'
import { ModalClose } from 'src/Components/Modal'

import styles from './MortgagesModal.module.scss'

const MortgagesModal = ({ children, closeLoans }) => (
  <Modal
    className={styles.modal}
    openKey='homeowner.loanFocus'
    toggle={closeLoans}
    type='quiet'
    overrideContent
  >
    {children}
    <ModalClose toggle={closeLoans} />
  </Modal>
)

export default MortgagesModal
